import { Cameras } from "@EspaceParkQC/sdk-call-center";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@EspaceParkQC/sdk-react";
import { Camera } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function IntercomCameras(): React.ReactElement {
  const { t } = useTranslation("main");

  return (
    <Card className="flex-1">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Camera className="size-5" />
          {t("intercom.camera-feed.title")}
        </CardTitle>
        <CardDescription>{t("intercom.camera-feed.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <Cameras
          render={({ camera, sipCamera, isSipCamera, hasSipVideoTracks }) => {
            if (isSipCamera && hasSipVideoTracks) {
              return (
                <div id="sip-camera" className="rounded-lg md:min-h-[500px] overflow-hidden border bg-muted">
                  {sipCamera}
                  <div className="p-2 bg-background border-t">
                    <p className="text-sm font-medium">{t("intercom.camera-feed.sip-camera-disconnection-warning")}</p>
                  </div>
                </div>
              );
            }

            if (camera) {
              return (
                <div className="rounded-lg md:min-h-[500px] overflow-hidden border bg-muted">
                  <img src={camera.url} alt={camera.name} className="w-full h-auto object-contain" />
                  {camera.name && (
                    <div className="p-2 bg-background border-t">
                      <p className="text-sm font-medium">{camera.name}</p>
                    </div>
                  )}
                </div>
              );
            }

            return (
              <div className="flex items-center justify-center md:min-h-[500px] rounded-lg border border-dashed bg-muted/50">
                <div className="text-center space-y-2">
                  <Camera className="size-8 mx-auto text-muted-foreground" />
                  <p className="text-sm text-muted-foreground">
                    {isSipCamera && !hasSipVideoTracks
                      ? t("intercom.camera-feed.sip-camera-has-no-video-tracks")
                      : t("intercom.camera-feed.no-camera-available")}
                  </p>
                </div>
              </div>
            );
          }}
        />
      </CardContent>
    </Card>
  );
}
